import React from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../components/Internal-nav';  
import DomesticCountertopData from '../data/domesticcountertopdata.json';
import './countertop-detail.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons';
import SEO from '../components/SEO';
import StructuredData from '../components/StructuredData';

function DomesticCountertopDetail() {
    const { slug } = useParams();
    var val = slug;
    var countertop = DomesticCountertopData.Countertops.find(function(item) {
        return item.url === val;
    });

    const countertopData = countertop[0];
    const fullDescription = `${countertopData.productName} - ${countertopData.standardFeatures?.map(f => f.feature).join('. ')}`;
    const keywords = `kitchen countertops, bathroom countertops, domestic countertops, ${countertopData.productName}, ${countertopData.colors?.map(c => c.colorName).join(', ')}`;

    return (
        <div className='App'>
            <SEO 
                title={countertopData.productName}
                description={fullDescription}
                keywords={keywords}
                canonicalUrl={`https://bcsurfacesupply.com/custom-countertops/${slug}`}
                ogImage={countertopData.imageurl}
            />
            <StructuredData 
                productData={{
                    name: countertopData.productName,
                    description: fullDescription,
                    image: countertopData.imageurl,
                    brand: countertopData.brand,
                    price: countertopData.price,
                    inStock: true,
                    manufacturer: countertopData.manufacturer
                }}
                productType="Domestic Countertop"
            />
            <header>
                <Navbar />
            </header>

            <div className='countertop-detail'>
                <div className='detail-left'>
                    <img className='large-product' src={countertopData.imageurl} alt={countertopData.altText} />
                    <div className='finish-options'>
                        <h3>More Finish Options</h3>
                        <div className='colors'>
                            {countertopData.colors ? 
                                countertopData.colors.map((d,i) => (
                                    <div key={i} style={{
                                        backgroundColor: `${d.encodedColor}`
                                    }} className="color-name">
                                        <div>{d.colorName}</div>
                                    </div>
                                ))
                                : 'loading'}
                        </div>
                    </div>
                    <div className='quote-request'>
                        <h3>Call Today to Get a Quote</h3>
                        <a href="tel:2603213092" className='quote-button'>
                            <FontAwesomeIcon icon={faMobileAlt} /> (260) 321-3092
                        </a>
                    </div>
                </div>

                <div className='detail-right'>
                    <h2>{countertopData.productName}</h2>
                    <div className='feature-section'>
                        <h3>Door Features</h3>
                        <ul className='features'>
                            {countertopData.doorFeatures ? 
                                countertopData.doorFeatures.map((d,i) => (
                                    <li key={i}>{d.feature}</li>
                                ))
                                : 'loading'}
                        </ul>
                    </div>
                    <div className='feature-section'>
                        <h3>Additional Features</h3>
                        <ul className='features'>
                            {countertopData.additionalFeatures ? 
                                countertopData.additionalFeatures.map((d,i) => (
                                    <li key={i}>{d.feature}</li>
                                ))
                                : 'loading'}
                        </ul>
                    </div>
                    <div className='feature-section'>
                        <h3>Standard Features</h3>
                        <ul className='features'>
                            {countertopData.standardFeatures ? 
                                countertopData.standardFeatures.map((d,i) => (
                                    <li key={i}>{d.feature}</li>
                                ))
                                : 'loading'}
                        </ul>
                    </div>
                    <div className='disclaimer'>
                        * When painted, door and drawer front construction will be changed to HDF.
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DomesticCountertopDetail;